import elearningRoutes from 'modules/trainingLibrary/Elearning/routing/routes'

const routes = {
  root: `${elearningRoutes.root}/details`,
}

export default routes
